<template>
  <div class="container-iframe mb20" :style="iframe.styleContainer">
    <iframe
      :src="url"
      class="iframe"
      :style="iframe.styleIframe"
      frameborder="0"
      scrolling="yes"
      allowfullscreen
    >
    </iframe>
  </div>
</template>
<script>
import { mapState } from "vuex"
export default {
  data() {
    return {
      iframe: {
        styleIframe: null,
        styleContainer: null,
      },
      url: "",
    };
  },
  computed: {
    ...mapState({
        banner_image_url: state => state.survey.banner_image_url,
    }),
    isAccessSurvey() {
      if(this.banner_image_url) {
          return true
      } else {
          return false
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('survey/getSurvey')
    if (!this.isAccessSurvey) {
      this.$router.push('/');
      return;
    }
    let urlParam = new URL(document.location).searchParams;
    this.url = `${process.env.MIX_SURVEY_BUCKET_URL + urlParam.get("survey_name")}.html`;
    this.surveyTracking(this.$t("survey"), window.location.href.split('/')[3]);
  },
  methods: {
    setHeightIframe() {
      const heightScreen = window.innerHeight;
      const heightAlreadyUsed = 300;
      this.iframe.styleIframe = {
        height: heightScreen + "px",
      };
      this.iframe.styleContainer = {
        height: heightScreen - heightAlreadyUsed + "px",
      };
    },
  },
};
</script>

<style scoped>
.container-iframe {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: scroll;
  padding-bottom: 20%;
}
.container-iframe iframe {
  width: 100%;
  height: 100%;
}
.iframe {
  position: fixed;
  width: 100%;
  left: 0;
}
</style>